// extracted by mini-css-extract-plugin
export default {"cards":"PricingCards_cards__tZKZN"};